module.exports = import('./openhps-rdf.es.min.js');